module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_30.77db7d7e.mp3";